<script setup lang="ts">
import Skeleton_SpeechBubbleUrl from '@Shared/components/visuals/visualAssets/Skeleton_SpeechBubble.svg?url';
</script>
<template>
  <div>
    <div class="loading-gradient h-1" style="border-radius: 8px 8px 0 0"></div>
    <div class="border-solid border-[#f5f5f5] border-1 font-family[Roboto]" style="border-radius: 0 0 8px 8px">
      <div class="flex flex-row py-4 pl-4 border-0 border-b-1 border-solid border-[#f5f5f5]">
        <img :src="Skeleton_SpeechBubbleUrl" class="mt-auto mb-auto min-w-24px h-24px" alt="" />
        <div class="flex flex-col pl-3 max-w-50% mr-auto">
          <div class="color-[#4F4F4F] loading-gradient h-8px w-140px border-rd-5"></div>
          <div class="color-[#828282] flex flex-row h-8px pt-1">
            <div class="loading-gradient border-rd-5 w-56px"></div>
            <div class="w-4px"></div>
            <div class="pl-2 loading-gradient border-rd-5 w-56px"></div>
          </div>
        </div>
        <div class="flex flex-row items-center h-24px max-w-45%">
          <svg
            class="min-w-9px h-24px ml-auto"
            viewBox="0 0 9 24"
            fill="url(#line-gradient)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9 0H1.3927C0.0839375 0 -0.499334 2.18278 0.516198 3.27885L7.26936 10.567C7.95411 11.3057 7.95411 12.6939 7.26936 13.4326L0.516198 20.7208C-0.499334 21.8168 0.0839375 23.9996 1.3927 23.9996H9V0Z"
            />
          </svg>
          <div
            class="w-56px flex flex-row h-24px border-0 border-r-1 border-solid loading-gradient border-[#f5f5f5]"
          ></div>
        </div>
      </div>
      <div class="px-4 pt-3 pb-4">
        <div class="loading-gradient h-8px w-95% border-rd-5"></div>
        <div class="loading-gradient h-8px w-95% border-rd-5 mt-1"></div>
        <div class="loading-gradient h-8px w-88px border-rd-5 mt-4"></div>
      </div>
    </div>
  </div>
</template>
